// extracted by mini-css-extract-plugin
var _1 = "TagContent-modulecontent__vO2rq";
var _2 = "TagContent-modulecontentWithMeta__MKhU0";
var _3 = "TagContent-modulesecondText__Dr5Eu";
var _4 = "TagContent-modulesecondTextSlashed__kukGj";
var _5 = "TagContent-moduletext__PX78H";
export { _1 as "content", _2 as "contentWithMeta", _3 as "secondText", _4 as "secondTextSlashed", _5 as "text" }
